/**
 * Whether a detail page should offer a way back, and where back is.
 *
 * A case opened in a new tab has nowhere to go: the tab's history begins at
 * that case, so a back control would either do nothing or leave the app. One
 * opened from the list does have somewhere, and it should be the list the
 * reader actually came from — not a hardcoded path, which is how the property
 * page ended up sending redesign users into the old design.
 *
 * Two signals, in order of confidence:
 *
 *   location.state.from  the list sets it when it links to a case, so it names
 *                        the exact list — motor or property, old design or new
 *   location.key         react-router gives the first entry of a session the
 *                        key "default"; anything else means we navigated here
 *                        from somewhere else in the app
 *
 * A new tab has neither, which is exactly the case that should show nothing.
 */

export const CASES_STATE_KEY = "from";

/** True when there is somewhere to go back to. */
export const canGoBack = (location) => {
  if (!location) return false;
  if (location.state?.[CASES_STATE_KEY]) return true;
  return Boolean(location.key) && location.key !== "default";
};

/**
 * The path to return to, or null to mean "one step back in history".
 *
 * Preferring the recorded path over history(-1) matters when the reader has
 * walked case to case: -1 would return to the previous CASE, and they asked
 * for the list.
 */
export const backTarget = (location) => location?.state?.[CASES_STATE_KEY] || null;
